/*!
 * vyzio FAQ-Chat – einfacher, regelbasierter Kunden-Assistent
 * Beantwortet häufige Fragen zu Versand, Rückgabe, Zahlung, Garantie u.v.m.,
 * und sucht bei Produktfragen live im eigenen Shop-Katalog (öffentliche
 * Shopify-Such-API der eigenen Domain – kein externer Dienst, keine
 * Datenübertragung an Dritte, läuft komplett im Browser).
 */
(function () {
  "use strict";

  if (window.__vyzioFaqChatLoaded) return;
  window.__vyzioFaqChatLoaded = true;

  var KB = [
    {
      id: "versand",
      keywords: ["versand", "lieferung", "liefern", "lieferzeit", "paket", "spedition", "dhl", "dpd", "wie lange dauert", "wann kommt"],
      answer: "Wir liefern innerhalb Deutschlands – an Privatadressen ebenso wie an Kitas, Kliniken und Praxen. Je nach Größe der Bestellung erfolgt der Versand per Paketdienst (DPD, DHL) oder per Spedition bei sperrigen Artikeln. Die voraussichtliche Lieferzeit findest du in deiner Versandbestätigung; individuell gefertigte Produkte aus unserer Manufaktur können etwas länger dauern. Eine Lieferung an DHL-Packstationen ist leider nicht möglich."
    },
    {
      id: "versandkosten",
      keywords: ["versandkosten", "portofrei", "kostenlos versand", "was kostet der versand", "versandgebühr", "verpackungskosten"],
      answer: "Die Versandkosten richten sich nach Gewicht und Größe deiner Bestellung. Die genauen Kosten siehst du transparent im Warenkorb sowie im Checkout, bevor du deine Bestellung abschließt."
    },
    {
      id: "widerruf",
      keywords: ["rückgabe", "widerruf", "zurückschicken", "umtausch", "retoure", "geld zurück", "stornieren", "widerrufen"],
      answer: "Als Verbraucher hast du ein 14-tägiges Widerrufsrecht ab Erhalt der Ware – ohne Angabe von Gründen. Am einfachsten teilst du uns den Widerruf formlos per E-Mail an info@vyzio.de mit. Die genauen Bedingungen findest du in unserer Widerrufsbelehrung."
    },
    {
      id: "zahlung",
      keywords: ["zahlung", "bezahlen", "zahlen", "paypal", "klarna", "kreditkarte", "rechnung", "ratenzahlung", "apple pay", "google pay", "zahlungsmittel", "zahlart"],
      answer: "Im Checkout stehen dir verschiedene Zahlarten zur Verfügung, u. a. Kreditkarte, Apple Pay und Google Pay sowie in der Regel PayPal und Klarna. Welche Optionen genau verfügbar sind, siehst du direkt beim Bezahlvorgang."
    },
    {
      id: "kontakt",
      keywords: ["kontakt", "telefon", "anrufen", "email", "e-mail", "mail", "erreichen", "ansprechpartner", "hotline"],
      answer: "Du erreichst uns per E-Mail an info@vyzio.de oder telefonisch unter 02921-3548422. Wir melden uns so schnell wie möglich bei dir."
    },
    {
      id: "ueber-uns",
      keywords: ["wer seid ihr", "über vyzio", "firma", "unternehmen", "mk seats", "hersteller"],
      answer: "vyzio ist eine Marke der MK Seats GmbH mit Sitz in Soest. Wir gestalten kindgerechte Möbel und Ausstattung für Kitas, Reha-Einrichtungen, Therapiepraxen und Zuhause – von Bällebädern über Therapie- und Sitzkissen bis zu Reha-Ausstattung."
    },
    {
      id: "kreisel",
      keywords: ["bestseller", "empfehlung", "beliebtestes produkt", "meistverkauft"],
      answer: "Unser meistverkauftes Produkt ist der vyzio Kreisel – ein Trainings- und Therapiekreisel für Balance und Motorik. Du findest ihn direkt über unser Hauptmenü oder die Suche."
    },
    {
      id: "sortiment",
      keywords: ["sortiment", "was verkauft ihr", "angebot", "kategorien"],
      answer: "Unser Sortiment umfasst u. a. Möbel für den Spielbereich, Reha-Ausstattung, Bällebäder, Therapie- und Sitzkissen sowie Klappmatratzen und Faltliegen für Kinder. Alle Kategorien findest du im Hauptmenü oben – oder frag mich einfach direkt nach einem bestimmten Produkt, ich suche dann live in unserem Katalog."
    },
    {
      id: "institutionen",
      keywords: ["kita", "kindergarten", "klinik", "praxis", "einrichtung", "b2b", "gewerblich", "geschäftskunde", "träger", "mengenrabatt", "staffelpreis", "großbestellung"],
      answer: "Ja, wir liefern nicht nur an Privatpersonen, sondern auch an Kindergärten, Kliniken, Praxen und andere Einrichtungen. Bei größeren Bestellungen oder Mengenanfragen sprich uns gerne direkt per E-Mail an info@vyzio.de an – wir finden eine passende Lösung."
    },
    {
      id: "abholung",
      keywords: ["abholen", "abholung", "selbstabholung", "vor ort kaufen"],
      answer: "Eine Selbstabholung ist aus logistischen Gründen leider nicht möglich – alle Bestellungen werden ausschließlich versendet."
    },
    {
      id: "reklamation",
      keywords: ["defekt", "kaputt", "mangel", "reklamation", "beschädigt", "fehlerhaft"],
      answer: "Das tut uns leid! Bitte melde dich mit deiner Bestellnummer und – wenn möglich – einem Foto direkt per E-Mail an info@vyzio.de bei uns, damit wir das schnell für dich klären können."
    },
    {
      id: "garantie",
      keywords: ["garantie", "gewährleistung", "wie lange garantie", "garantiezeit"],
      answer: "Für alle Produkte gilt die gesetzliche Gewährleistung von 2 Jahren ab Kaufdatum. Solltest du innerhalb dieser Zeit einen Mangel feststellen, melde dich einfach mit deiner Bestellnummer per E-Mail an info@vyzio.de – wir kümmern uns darum."
    },
    {
      id: "material",
      keywords: ["material", "materialien", "stoff", "bezug", "woraus besteht", "schaumstoff", "füllung", "inhaltsstoffe", "oeko-tex", "reach"],
      answer: "Die verwendeten Materialien unterscheiden sich je nach Produkt – die genauen Angaben (Bezugsstoff, Füllung, Zertifizierungen wie CE, OEKO-TEX oder REACH-Konformität, sofern zutreffend) findest du jeweils in der Produktbeschreibung. Wenn du zu einem bestimmten Produkt mehr wissen möchtest, nenn mir einfach den Namen."
    },
    {
      id: "montage",
      keywords: ["montage", "aufbau", "zusammenbauen", "montieren", "aufbauen", "vormontiert", "selbst aufbauen"],
      answer: "Das hängt vom Produkt ab: Kleinere Artikel kommen meist einsatzbereit an, größere Möbelstücke oder Bällebäder erfordern in der Regel einen einfachen Aufbau, für den eine Anleitung beiliegt. Details dazu findest du in der jeweiligen Produktbeschreibung – oder frag mich nach einem bestimmten Produkt."
    },
    {
      id: "rabatt",
      keywords: ["rabatt", "rabattcode", "gutschein", "gutscheincode", "aktionscode", "prozente", "nachlass", "sale"],
      answer: "Aktuelle Angebote und Aktionen zeigen wir dir direkt im Shop bzw. im Checkout an. Einen dauerhaften Rabattcode gibt es nicht – am besten schaust du im Shop vorbei oder abonnierst unseren Newsletter, um nichts zu verpassen."
    },
    {
      id: "bestellstatus",
      keywords: ["bestellstatus", "wo ist meine bestellung", "tracking", "sendungsverfolgung", "trackingnummer", "bestellung verfolgen", "wann kommt meine bestellung"],
      answer: "Den Status deiner Bestellung samt Sendungsverfolgung findest du in der Versandbestätigung, die du per E-Mail erhalten hast. Falls du sie nicht findest oder Fragen zu deiner Lieferung hast, schreib uns gerne mit deiner Bestellnummer an info@vyzio.de."
    },
    {
      id: "beleg",
      keywords: ["rechnungskopie", "beleg", "quittung", "rechnung erhalten", "rechnung nochmal"],
      answer: "Deine Rechnung wird dir automatisch per E-Mail nach dem Kauf zugeschickt. Falls du sie nicht findest oder eine Kopie benötigst, schreib uns einfach mit deiner Bestellnummer an info@vyzio.de."
    }
  ];

  var FALLBACK = "Das habe ich leider noch nicht auf dem Schirm. Schreib uns gerne direkt per E-Mail an info@vyzio.de oder ruf uns unter 02921-3548422 an – unser Team hilft dir gern persönlich weiter.";
  var GREETING = "Hallo! 👋 Ich bin der automatische vyzio-Assistent. Frag mich zu Versand, Rückgabe, Zahlung, Garantie & mehr – oder direkt nach einem Produkt (z. B. \"Habt ihr ein Bällebad?\") und ich suche live in unserem Sortiment. Worüber möchtest du mehr wissen?";
  var PRODUCTS_INTRO = "Das habe ich dazu in unserem Shop gefunden:";
  var PRODUCTS_NONE = "Dazu habe ich in unserem aktuellen Sortiment leider nichts Passendes gefunden. Schreib uns gerne direkt per E-Mail an info@vyzio.de – wir helfen dir persönlich weiter, oder nutze oben die Suche mit einem anderen Begriff.";
  var UNAVAILABLE_TAG = "aktuell nicht auf Lager";

  var QUICK_REPLIES = [
    { label: "Versand & Lieferzeit", id: "versand" },
    { label: "Rückgabe & Widerruf", id: "widerruf" },
    { label: "Zahlungsmethoden", id: "zahlung" },
    { label: "Garantie", id: "garantie" },
    { label: "Kontakt", id: "kontakt" }
  ];

  function scoreKB(text) {
    var normalized = text.toLowerCase();
    var best = null;
    var bestScore = 0;
    for (var i = 0; i < KB.length; i++) {
      var entry = KB[i];
      var score = 0;
      for (var j = 0; j < entry.keywords.length; j++) {
        if (normalized.indexOf(entry.keywords[j]) !== -1) score++;
      }
      if (score > bestScore) {
        bestScore = score;
        best = entry;
      }
    }
    return { best: best, bestScore: bestScore };
  }

  function byId(id) { return KB.filter(function (e) { return e.id === id; })[0]; }

  function formatPrice(raw) {
    var num = parseFloat(raw);
    if (isNaN(num)) return null;
    try {
      return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(num);
    } catch (e) {
      return num.toFixed(2).replace(".", ",") + " €";
    }
  }

  function searchProducts(query) {
    var url = "/search/suggest.json?q=" + encodeURIComponent(query) +
      "&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last" +
      "&resources[options][fields]=title,product_type,variants.title";
    return fetch(url, { headers: { "Accept": "application/json" } })
      .then(function (res) {
        if (!res.ok) throw new Error("search failed");
        return res.json();
      })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        return products.slice(0, 3);
      })
      .catch(function () { return []; });
  }

  var css = ""
    + "#vyzioFaqChatBubble{position:fixed;bottom:24px;right:24px;width:60px;height:60px;border-radius:50%;background:#1f2d3d;color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 16px rgba(0,0,0,.25);cursor:pointer;z-index:999999;transition:transform .15s ease;}"
    + "#vyzioFaqChatBubble:hover{transform:scale(1.06);}"
    + "#vyzioFaqChatBubble svg{width:28px;height:28px;fill:#fff;}"
    + "#vyzioFaqChatBadge{position:absolute;top:-2px;right:-2px;background:#e0483e;color:#fff;font-size:11px;font-weight:700;min-width:18px;height:18px;border-radius:9px;display:flex;align-items:center;justify-content:center;padding:0 4px;box-shadow:0 0 0 2px #fff;}"
    + "#vyzioFaqChatPanel{position:fixed;bottom:96px;right:24px;width:340px;max-width:92vw;height:490px;max-height:74vh;background:#fff;border-radius:14px;box-shadow:0 10px 40px rgba(0,0,0,.25);display:none;flex-direction:column;overflow:hidden;z-index:999999;font-family:inherit;}"
    + "#vyzioFaqChatPanel.vyzio-open{display:flex;}"
    + "#vyzioFaqChatHeader{background:#1f2d3d;color:#fff;padding:12px 14px;font-size:15px;font-weight:600;display:flex;align-items:center;gap:10px;}"
    + "#vyzioFaqChatAvatar{width:32px;height:32px;border-radius:50%;background:#33465c;display:flex;align-items:center;justify-content:center;font-size:15px;font-weight:700;flex-shrink:0;}"
    + "#vyzioFaqChatHeaderText{flex:1;}"
    + "#vyzioFaqChatHeader small{display:block;font-weight:400;font-size:11px;opacity:.75;margin-top:2px;}"
    + "#vyzioFaqChatClose{cursor:pointer;font-size:20px;line-height:1;padding:0 4px;opacity:.8;}"
    + "#vyzioFaqChatClose:hover{opacity:1;}"
    + "#vyzioFaqChatMessages{flex:1;overflow-y:auto;padding:14px;background:#f7f7f8;}"
    + ".vyzio-msg{max-width:88%;margin-bottom:10px;padding:10px 12px;border-radius:12px;font-size:13.5px;line-height:1.45;white-space:pre-wrap;}"
    + ".vyzio-msg.bot{background:#eef0f3;color:#1f2d3d;border-bottom-left-radius:2px;}"
    + ".vyzio-msg.user{background:#1f2d3d;color:#fff;margin-left:auto;border-bottom-right-radius:2px;}"
    + ".vyzio-typing{display:inline-flex;gap:3px;align-items:center;padding:2px 0;}"
    + ".vyzio-typing span{width:6px;height:6px;border-radius:50%;background:#9aa3ad;display:inline-block;animation:vyzioBounce 1.2s infinite ease-in-out;}"
    + ".vyzio-typing span:nth-child(2){animation-delay:.15s;}"
    + ".vyzio-typing span:nth-child(3){animation-delay:.3s;}"
    + "@keyframes vyzioBounce{0%,60%,100%{transform:translateY(0);opacity:.5;}30%{transform:translateY(-4px);opacity:1;}}"
    + ".vyzio-product-item{display:flex;align-items:center;gap:8px;color:#1f2d3d;text-decoration:none;font-size:13px;margin-top:6px;padding:8px;background:#fff;border:1px solid #d7dae0;border-radius:8px;}"
    + ".vyzio-product-item:hover{border-color:#1f2d3d;}"
    + ".vyzio-product-item img{width:42px;height:42px;border-radius:6px;object-fit:cover;flex-shrink:0;background:#f0f0f0;}"
    + ".vyzio-product-info{display:flex;flex-direction:column;gap:2px;}"
    + ".vyzio-product-item .vyzio-price{font-weight:600;}"
    + ".vyzio-product-item .vyzio-unavailable{color:#a33;font-size:11px;}"
    + ".vyzio-search-more{display:inline-block;margin-top:8px;font-size:12.5px;color:#1f2d3d;text-decoration:underline;}"
    + "#vyzioFaqChatQuick{display:flex;flex-wrap:wrap;gap:6px;padding:0 14px 10px;background:#f7f7f8;}"
    + ".vyzio-chip{border:1px solid #d7dae0;background:#fff;color:#1f2d3d;font-size:12px;padding:6px 10px;border-radius:16px;cursor:pointer;}"
    + ".vyzio-chip:hover{background:#eef0f3;}"
    + "#vyzioFaqChatInputRow{display:flex;border-top:1px solid #e5e7eb;padding:10px;gap:8px;background:#fff;}"
    + "#vyzioFaqChatInput{flex:1;border:1px solid #d7dae0;border-radius:20px;padding:9px 14px;font-size:13.5px;outline:none;}"
    + "#vyzioFaqChatInput:focus{border-color:#1f2d3d;}"
    + "#vyzioFaqChatSend{background:#1f2d3d;color:#fff;border:none;border-radius:20px;padding:0 16px;font-size:13px;cursor:pointer;}"
    + "#vyzioFaqChatSend:hover{background:#33465c;}"
    + "@media (max-width:480px){#vyzioFaqChatPanel{right:12px;bottom:88px;width:calc(100vw - 24px);}#vyzioFaqChatBubble{right:16px;bottom:16px;}}";

  var style = document.createElement("style");
  style.setAttribute("data-vyzio-faqchat", "true");
  style.textContent = css;
  document.head.appendChild(style);

  var bubble = document.createElement("div");
  bubble.id = "vyzioFaqChatBubble";
  bubble.setAttribute("role", "button");
  bubble.setAttribute("aria-label", "Chat öffnen");
  bubble.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.03 2 11c0 2.42 1.09 4.62 2.86 6.24L4 22l5.11-1.34C10.13 20.87 11.05 21 12 21c5.52 0 10-4.03 10-9s-4.48-10-10-10z"/></svg>';
  document.body.appendChild(bubble);

  var badgeShown = false;
  try {
    if (!localStorage.getItem("vyzioFaqChatSeen")) {
      setTimeout(function () {
        if (panel.classList.contains("vyzio-open")) return;
        var badge = document.createElement("div");
        badge.id = "vyzioFaqChatBadge";
        badge.textContent = "1";
        bubble.appendChild(badge);
        badgeShown = true;
      }, 3500);
    }
  } catch (e) { /* localStorage unavailable – ignore, badge simply won't show */ }

  var panel = document.createElement("div");
  panel.id = "vyzioFaqChatPanel";
  panel.innerHTML =
    '<div id="vyzioFaqChatHeader"><div id="vyzioFaqChatAvatar">V</div><div id="vyzioFaqChatHeaderText">vyzio Kunden-Chat<small>Automatischer Assistent &middot; keine echte Person</small></div><div id="vyzioFaqChatClose" aria-label="Schließen">&times;</div></div>' +
    '<div id="vyzioFaqChatMessages"></div>' +
    '<div id="vyzioFaqChatQuick"></div>' +
    '<div id="vyzioFaqChatInputRow"><input id="vyzioFaqChatInput" type="text" placeholder="Deine Frage eingeben..." /><button id="vyzioFaqChatSend">Senden</button></div>';
  document.body.appendChild(panel);

  var messagesEl = panel.querySelector("#vyzioFaqChatMessages");
  var quickEl = panel.querySelector("#vyzioFaqChatQuick");
  var inputEl = panel.querySelector("#vyzioFaqChatInput");
  var sendBtn = panel.querySelector("#vyzioFaqChatSend");
  var closeBtn = panel.querySelector("#vyzioFaqChatClose");

  function addMessage(text, who) {
    var el = document.createElement("div");
    el.className = "vyzio-msg " + (who === "user" ? "user" : "bot");
    el.textContent = text;
    messagesEl.appendChild(el);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return el;
  }

  function addTyping() {
    var el = document.createElement("div");
    el.className = "vyzio-msg bot";
    el.innerHTML = '<span class="vyzio-typing"><span></span><span></span><span></span></span>';
    messagesEl.appendChild(el);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return el;
  }

  function addProductResults(products, query) {
    var wrap = document.createElement("div");
    wrap.className = "vyzio-msg bot";
    var intro = document.createElement("div");
    intro.textContent = PRODUCTS_INTRO;
    wrap.appendChild(intro);
    products.forEach(function (p) {
      var link = document.createElement("a");
      link.className = "vyzio-product-item";
      link.href = p.url || "#";

      if (p.image) {
        var img = document.createElement("img");
        img.src = p.image;
        img.alt = "";
        img.loading = "lazy";
        link.appendChild(img);
      }

      var info = document.createElement("span");
      info.className = "vyzio-product-info";

      var title = document.createElement("span");
      title.textContent = p.title || "";
      info.appendChild(title);

      var priceText = formatPrice(p.price);
      if (priceText) {
        var price = document.createElement("span");
        price.className = "vyzio-price";
        price.textContent = priceText;
        info.appendChild(price);
      }

      if (p.available === false) {
        var unavailable = document.createElement("span");
        unavailable.className = "vyzio-unavailable";
        unavailable.textContent = UNAVAILABLE_TAG;
        info.appendChild(unavailable);
      }

      link.appendChild(info);
      wrap.appendChild(link);
    });

    if (query) {
      var more = document.createElement("a");
      more.className = "vyzio-search-more";
      more.href = "/search?q=" + encodeURIComponent(query) + "&type=product";
      more.textContent = "Alle Suchergebnisse ansehen →";
      wrap.appendChild(more);
    }

    messagesEl.appendChild(wrap);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function renderQuickReplies() {
    quickEl.innerHTML = "";
    QUICK_REPLIES.forEach(function (q) {
      var chip = document.createElement("div");
      chip.className = "vyzio-chip";
      chip.textContent = q.label;
      chip.addEventListener("click", function () {
        addMessage(q.label, "user");
        var entry = byId(q.id);
        addMessage(entry ? entry.answer : FALLBACK, "bot");
      });
      quickEl.appendChild(chip);
    });
  }

  var initialized = false;
  function openPanel() {
    panel.classList.add("vyzio-open");
    var badge = document.getElementById("vyzioFaqChatBadge");
    if (badge) badge.remove();
    try { localStorage.setItem("vyzioFaqChatSeen", "1"); } catch (e) { /* ignore */ }
    if (!initialized) {
      initialized = true;
      addMessage(GREETING, "bot");
      renderQuickReplies();
    }
    inputEl.focus();
  }

  function closePanel() {
    panel.classList.remove("vyzio-open");
  }

  bubble.addEventListener("click", function () {
    if (panel.classList.contains("vyzio-open")) { closePanel(); } else { openPanel(); }
  });
  closeBtn.addEventListener("click", closePanel);

  function handleSend() {
    var text = inputEl.value.trim();
    if (!text) return;
    addMessage(text, "user");
    inputEl.value = "";

    var scored = scoreKB(text);
    if (scored.bestScore > 0) {
      var typingEl = addTyping();
      setTimeout(function () {
        typingEl.remove();
        addMessage(scored.best.answer, "bot");
      }, 250);
      return;
    }

    var searchTypingEl = addTyping();
    searchProducts(text).then(function (products) {
      searchTypingEl.remove();
      if (products.length) {
        addProductResults(products, text);
      } else {
        addMessage(PRODUCTS_NONE, "bot");
      }
    });
  }

  sendBtn.addEventListener("click", handleSend);
  inputEl.addEventListener("keydown", function (e) {
    if (e.key === "Enter") handleSend();
  });
})();
